import type { ReduxActionMeta } from "../types/ActionMeta";

export const refreshLicenseInfoMeta: ReduxActionMeta = {
    refreshLicenseInfoAfterCompletion: true,
};

export const updateUnitsFromRemainingUnitsMeta: ReduxActionMeta = {
    updateUnitsFromRemainingUnits: true,
};

export const withLicenseRefreshMeta = (
    meta?: ReduxActionMeta
): ReduxActionMeta => ({
    ...meta,
    refreshLicenseInfoAfterCompletion: true,
});

export const withRemainingUnitsUpdateMeta = (
    meta?: ReduxActionMeta
): ReduxActionMeta => ({
    ...meta,
    updateUnitsFromRemainingUnits: true,
});
